<template>
	<div>
		<p class="create-post-title">Please add instructions or comments</p>
		<div class="create-post">
			<form>
				<div class="create-post-header">
					<div>{{ fullName }}</div>
				</div>
				<div class="create-post-body">
					<div class="create-post-body-content">
						<BaseTextarea v-model="post.post_message" rows="7" :errorMsg="validationErrors.post_message"/>
					</div>
					<div
						v-if="
							post.post_attachments &&
								post.post_attachments.length > 0
						"
						class="create-post-body-attachments"
					>
						<BaseAttachment :attachments="post.post_attachments" @input="post.post_attachments = $event"/>
					</div>
				</div>

				<div class="create-post-footer">
					<div class="create-post-footer-file-input">
						<label>Upload images, documents or other ad component files</label>
						<BaseFileInput
							:attachments="post.post_attachments"
							@input="post.post_attachments = $event"
							:attachmentId="attachmentId"
							@add="addAttachmentId"
						/>
					</div>

					<div
						class="create-post-footer-button"
						@click.prevent="openApproveModal"
						v-if="isApprovedButton"
					>Approve Job</div>
					<div class="create-post-footer-button" @click.prevent="clickSubmit">Submit</div>
					<mdb-modal @close="closeApproveModal" v-if="modal">
						<mdb-modal-header>
							<mdb-modal-title>Approve final draft and run</mdb-modal-title>
						</mdb-modal-header>
						<mdb-modal-body>
							By approving this job I acknowledge that I have
							viewed the latest draft and am wholly satisfied that
							it fulfils all of my requirements to be published as
							is.
						</mdb-modal-body>
						<mdb-modal-footer>
							<mdb-btn color="secondary" @click.native.prevent="closeApproveModal">Close</mdb-btn>
							<mdb-btn class="btn-color-primary" @click.native.prevent="clickApprove">Approve Job</mdb-btn>
						</mdb-modal-footer>
					</mdb-modal>
					<!-- 
					<div class="button-group">
						<mdb-btn
							color="primary"
							@click.native.prevent="clickSubmit"
							class="mr-0"
							>submit</mdb-btn
						>
						<mdb-btn color="primary"
							>Approve Final Draft and Run</mdb-btn
						>
					</div>-->
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import {
	mdbBtn,
	mdbModal,
	mdbModalHeader,
	mdbModalTitle,
	mdbModalBody,
	mdbModalFooter
} from 'mdbvue'
import * as yup from 'yup'
import { getValidationErrors, isStaff } from '@/utils/Help.js'
import moment from 'moment'
import { mapState } from 'vuex'
import NProgress from 'nprogress'

const schema = yup.object().shape({
	post_message: yup
		.string()
		.label('Post Message')
		.required()
})

export default {
	name: 'CreatePost',
	components: {
		mdbBtn,
		mdbModal,
		mdbModalHeader,
		mdbModalTitle,
		mdbModalBody,
		mdbModalFooter
	},
	data() {
		return {
			post: this.createFreshPost(),
			validationErrors: {},
			attachmentId: 1,
			modal: false
		}
	},
	computed: {
		...mapState({
			posts: state => state.post.posts
		}),
		fullName() {
			const user = JSON.parse(sessionStorage.user)
			return user.name
		},
		isStaff() {
			return isStaff()
		},
		isApprovedButton() {
			const job_status = this.job_status
			const isApprovedButton = job_status === 'processing' ? true : false
			return isApprovedButton && !this.isStaff
		}
	},
	props: {
		job_id: {
			type: String,
			required: true
		},
		job_status: {
			type: String,
			required: true
		}
	},
	methods: {
		createFreshPost() {
			const user = JSON.parse(sessionStorage.getItem('user'))
			const user_name = user.name
			const profile = user.profile
			const user_email = user.email
			return {
				job_id: this.job_id,
				post_title: 'post',
				post_message: '',
				post_attachments: [],
				user_name,
				profile,
				user_email
			}
		},
		addAttachmentId() {
			this.attachmentId += 1
		},
		async clickSubmit() {
			NProgress.start()
			this.post.create_time_stamp = moment()
				.utcOffset(600)
				.format()
			const { post_message } = this.post
			const userInput = { post_message }

			try {
				const postsCount = this.posts.length
				await schema.validate(userInput, {
					abortEarly: false
				})
				await this.$store.dispatch('post/createPost', {
					post: this.post
				})
				this.$store.dispatch('post/clearPosts')
				await this.$store.dispatch('post/getPosts', {
					job_id: this.job_id,
					pageSize: postsCount + 1,
					exclusivestartkey: JSON.stringify({})
				})
				const user = JSON.parse(sessionStorage.getItem('user'))
				const profile = user.profile
				if (profile === 'Staff') {
					await this.$store.dispatch('job/addUnreadStaffPost', {
						job_id: this.job_id
					})
				} else {
					await this.$store.dispatch('job/addUnreadClientPost', {
						job_id: this.job_id
					})
				}
				this.post = this.createFreshPost()
				NProgress.done()
			} catch (error) {
				// console.log(error)
				this.validationErrors = getValidationErrors(error)
				NProgress.done()
			}
		},
		openApproveModal() {
			this.modal = true
		},
		closeApproveModal() {
			this.modal = false
		},
		async clickApprove() {
			this.modal = false
			NProgress.start()
			const create_time_stamp = moment()
				.utcOffset(600)
				.format()
			const user = JSON.parse(sessionStorage.getItem('user'))
			const { name, profile, email } = user

			const post = {
				job_id: this.job_id,
				post_title: 'post',
				post_message: 'Client approved this job.',
				post_attachments: [],
				user_name: name,
				profile,
				user_email: email,
				create_time_stamp
			}

			try {
				await this.$store.dispatch('job/approveJob', {
					job_id: this.job_id
				})
				const postsCount = this.posts.length

				await this.$store.dispatch('post/createPost', {
					post
				})
				this.$store.dispatch('post/clearPosts')
				await this.$store.dispatch('post/getPosts', {
					job_id: this.job_id,
					pageSize: postsCount + 1,
					exclusivestartkey: JSON.stringify({})
				})
				await this.$store.dispatch('job/addUnreadClientPost', {
					job_id: this.job_id
				})
				this.post = this.createFreshPost()
				NProgress.done()
			} catch (error) {
				console.log(error)
				NProgress.done()
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/components/createPost.scss';
</style>
